import React from "react"
import "./style.scss"
import NewProducts from "../../cards/newproducts/index"
// import glassX from "../../../images/glassx.png"
// import discoverX from "../../../images/discoverx.png"
// import dashx from "../../../images/dashx.png"
import product1 from "../../../images/product1.png"
import product2 from "../../../images/product2.png"
import product3 from "../../../images/product3.png"
import product_4 from "../../../images/product_4.png"
import product_5 from "../../../images/product_5.png"


const WhyService = ({ discoverx, dashx, glassx }) => {
  const sectionData = {
    solutionsText: `Wersel is one of the best employee success platforms. But what makes it the best in the market?\n But should one choose a work desk for their business?\n Let’s learn why:`,
    products: [
      {
        featureTitle: "Performance Management",
        featureDescription:
          "It’s simple and efficient to manage employee performance using Wersel. The platform allows businesses to run performance reviews on a frequent basis, improving employee efficiency. Moreover, Wersel also facilitates public celebration of employee’s achievements.",
        featureImage: product1,
        imagePosition: "right",
        // url: "/products/discoverx/",
      },
      {
        featureTitle: "Employee Engagement Analysis",
        featureDescription:
          "Wersel offers features such as eNPS, Pulse and surveys, which can be used to identify employee opinions. Employees want their voices to be heard. The platform ensures that it isn’t just heard but properly analysed to retain top talent and maintain business growth.",
        featureImage: product2,
        imagePosition: "left",
        hack: "hack-2500",
        // url: "/products/dashx/",
      },
      {
        featureTitle: "Achieve Talent Acceleration",
        featureDescription:
          "Another wonderful thing about having Wersel is the ability to transform talent management into talent acceleration. Using the features such as Individual Development Plans, Career Tracks, etc., businesses can help employees achieve immense career growth.",
        featureImage: product3,
        imagePosition: "right",
        // url: "/products/glassx/",
      },
      {
        featureTitle: "Simplified Compensation Review",
        featureDescription:
          "Wersel brings a new and more efficient way of distributing compensations and appraisals. The platform connects employee performance with compensation. In other words, data-driven decisions are made based on performance analyses. This helps in driving employee retention and enhanced employee engagement.",
        featureImage: product_4,
        imagePosition: "left",
        // url: "/products/discoverx/",
      },
      {
        featureTitle: "HR Software Analysis",
        featureDescription:
          "The HRs can make data-driven decisions using Wersel. The features such as AI-powered sentiment analysis, unified dashboards, and continuous analytics helps HR drive innovation and impact. The platform offers a connection between employee insights and decision-making.",
        featureImage: product_5,
        imagePosition: "right",
        hack: "hack-2500",
        stylePadding: '10rem'
        // url: "/products/dashx/",
      },
    ],
    reasons: [
        {
            title: 'A workflow-aware architecture',
            description: 'With its robust capabilities that enable you to safely utilize, exchange, execute python AI/ETL scripts, or analyze data without ever decrypting or compromising privacy, Wersel Workdesk is specifically created for personally identifiable information (PII) data and PII workflows.',
        },
        {
            title: 'Access Control Focused on Privacy',
            description: 'Limit the types of data that are accessible and their formats. Only provide your support team with the PII they require to assist your clients while maintaining data privacy. You can limit data access by IP address, only display the last four digits of a passport number, and more. You can also provide access to only their designated customers during business hours. Always encrypted data analytics for data security and privacy.',
        },
        {
            title: 'Analysis of Always-Encrypted Data',
            description: "PII's potential can be unlocked while client data privacy is maintained. You can query PII data without decrypting it and get the masked dataset you require, whether you're creating a machine learning model, studying overall customer behavior, or creating safe data triggers.",
        },
    ],
  }
  return (
    <div className="homepage_productSection">
      <div className="text-area">
        <h4 className="title">
          Why Choose Wersel Workdesk
        </h4>
        <hr className="titleLine"/>
        <div>
        {sectionData.reasons &&
          sectionData.reasons.map((reason, index) => {
            return (
            <>
            <p className='subtitle'>{reason.title}</p>
            <p className="text">{reason.description}</p>
            </>
            )})}
        </div>
      </div>
    </div>
  )
}

export default WhyService
